// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_mOG","cls2":"Comments-cls2__Ln Comments-cls1_mOG"};